'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FLOATING_ALERT_DEFAULT_TIMEOUT = exports.FLOATING_ALERT_DEFAULT_TIMEOUT = 4000;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/alert/AlertConstants.js
// module id = 473
// module chunks = 0